import React, { Fragment, useEffect, useState } from "react";
import { CustomDialog, TitledTextField } from "../../../../../../../../../../common/components";
import { translate } from "../../../../../../../../../../common/providers";
import { isNonEmptyArray, roundTo, upsert } from "../../../../../../../../../../common/utils";
import styles from "../../DSIQuotasBlock.module.css";

const QuotaAllocationDialog = ({ allowedIntervals, companyName, onClose, onSubmit, open, quota }) => {
	const [localQuota, setLocalQuota] = useState([]);
	useEffect(() => {
		if (open && isNonEmptyArray(quota)) {
			setLocalQuota(quota.map((q) => ({ type: q.type, token: roundTo(q.token / 1000000, 2) })));
		}
	}, [open, quota]);
	const handleChangeQuota = (value, key) => {
		setLocalQuota((prev) => [...upsert(prev, { type: key, token: parseInt(value, 10) }, "type")]);
	};
	const handleClose = () => {
		setLocalQuota([]);
		onClose();
	};
	const handleSubmit = () => {
		onSubmit(localQuota);
		handleClose();
	};
	return (
		<CustomDialog
			open={open}
			submitDisabled={localQuota?.length === allowedIntervals?.length && !localQuota.every((lq) => lq.token >= 0)}
			submitText={translate("dsi.dsi-company.quotas.update.pop-up.submit")}
			title={translate("dsi.dsi-company.quotas.update.pop-up.title")}
			onClose={handleClose}
			onSubmit={handleSubmit}
		>
			<TitledTextField
				disabled
				required
				title={translate("dsi.dsi-company.quotas.update.pop-up.scope")}
				value={companyName}
			/>
			{allowedIntervals?.map((interval) => {
				const intervalQuota = localQuota?.find((lq) => lq.type === interval)?.token || 0;
				return (
					<Fragment key={interval}>
						<TitledTextField
							required
							adornment="M"
							placeholder="0"
							title={translate(`dsi.dsi-company.quotas.update.pop-up.${interval.toLowerCase()}`)}
							type="number"
							value={intervalQuota}
							onChange={(value) => handleChangeQuota(value, interval)}
						/>
						{intervalQuota < 0 && (
							<span className={styles.error}>{translate("common:company.quotas.error.number")}</span>
						)}
					</Fragment>
				);
			})}
		</CustomDialog>
	);
};
export default QuotaAllocationDialog;
